export default __webpack_public_path__ + "static/media/pin.c6ad37e4.svg";